import Quill from "quill";
// Constants
import { FONT_FAMILIES } from "app/App.constants";

const Font = Quill.import('formats/font') as any;

Font.whitelist = FONT_FAMILIES.map((fontFamily) => fontFamily.toLowerCase().replace(/\s/g, ''));

Quill.register(Font, true);